import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { AgGridReact } from 'ag-grid-react';
import { useMemo, useState } from "react";
import ErrorPage from "../../Layouts/Error";
import Loading from "../../Layouts/Loading";
import { fa_dateـetime } from "../../utils/Persian";
import { ICellRendererParams, ValueFormatterParams } from "@ag-grid-community/core";
import { useDeleteBookmarkMutation, useGetUserBookmarksQuery } from "../../Redux/Apis/bookmarkApi";
import Dictionary from "../../Components/Dictionary";
import { useCreateCardMutation } from "../../Redux/Apis/leitnerApi";
import { toast } from "react-toastify";

function Bookmark() {
    const [deleteBookmark] = useDeleteBookmarkMutation()
    const [createCard] = useCreateCardMutation()
    const [showDic, setShowDic] = useState<boolean>(false);
    const [popupContent, setPopupContent] = useState<string>('');

    const pagination = true;
    const paginationPageSize = 500;
    const paginationPageSizeSelector = [200, 500, 1000];

    const addToLeitner = async (word: string) => {
      try {
        // بدون تعیین box → خودکار به جعبه ۱ می‌رود
        await createCard({ front: word }).unwrap()
        toast.success(`«${word}» به لایتنر اضافه شد`)
      } catch (e:any) {
        toast.error('افزودن به لایتنر ناموفق بود')
      }
    }

    const CustomButtonComponent = (props: { values: number;word: string })  => {
        return <>
            <button className="btn btn-primary border border-secondary-subtle border-4 btn-sm ms-2" onClick={() => Translate(props.word) }>
                <FontAwesomeIcon icon={"eye"}/> مشاهده معنی
            </button>
            <button className="btn btn-success border border-secondary-subtle border-4 btn-sm ms-2" onClick={() => addToLeitner(props.word)}>
                <FontAwesomeIcon icon={"plus"}/> افزودن به لایتنر
            </button>
            <button className="btn btn-danger border border-secondary-subtle border-4 btn-sm ms-2" onClick={() => {window.confirm('آیا از حذف این کلمه اطمینان دارید؟') && deleteBookmark(props.values)} }>
                <FontAwesomeIcon icon={"trash"}/> حذف
            </button>
            </>;
        };

    const [colDefs] = useState([
        {
            headerName: "#",
            valueFormatter: (params: ValueFormatterParams) => {
                return `${parseInt(params.node!.id!) + 1}`;
            },
            flex: 0.2
        },
        { headerName: 'کلمه', field: "word",flex: 1 },
        { headerName: 'تاریخ ایجاد', field: "create_date", valueFormatter: (p: { data: { create_date: any; }; }) => fa_dateـetime(p.data.create_date),flex: 0.5},
        // { headerName: 'منبع کلمه', valueGetter: (p: { data: { Exam: { name: string }; }; }) => p.data?.Exam?.name },
        {
            field: "actions",
            headerName: "",
            cellRendererSelector: (params: ICellRendererParams) => {
                return {
                    component: CustomButtonComponent,
                    params: { values: params.data.id, word:  params.data.word},
                };
            },
            flex: 1,
        },
      ]);

      const defaultColDef = useMemo(() => {
        return {
            flex: 1,
        }
    }, []);

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useGetUserBookmarksQuery()

    const Translate = (selection: string) => {
        const selectedText = selection ? selection.toString().trim() : '';
        if (selectedText) {
            setPopupContent(selectedText);
            setShowDic(true);
        }
    };

    if(isError) return <ErrorPage data={error}/>

    return ( 
        <>
        <main className="col-lg-9">
            <div className="panel-surface p-3 mb-3 d-flex align-items-center justify-content-between">
                <h6 className="fw-bold m-0">کلمات بوکمارک‌شده</h6>
                <div className="small panel-muted">افزودن مستقیم به جعبه ۱</div>
            </div>

            <div className="panel-surface p-3">
                {isLoading && <Loading/>}
                {isSuccess && data &&  
                    <div className="ag-theme-quartz" style={{ height: 500 }}>
                        <AgGridReact
                            rowData={data}
                            columnDefs={colDefs as any}
                            enableRtl={true}
                            defaultColDef={defaultColDef}
                            pagination={pagination}
                            paginationPageSize={paginationPageSize}
                            paginationPageSizeSelector={paginationPageSizeSelector}
                        />
                    </div> }
            </div>
        </main>
        {showDic && (
            <Dictionary
                content={popupContent}
                onClose={() => setShowDic(false)}
            />
        )}
        </>
    );
    
}

export default Bookmark;
